export default __webpack_public_path__ + "static/media/Writer_HTB.89c3399a.md";